import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import BaseModal from '../../../modules/foundation/components/Modal';
import { EmailCaptureImagePropType } from '../EmailCapture.propTypes';
import Form from '../components/Form';
import { setFormAsClosed, formWasSubmitted, formWasClosed } from '../utils/storageUtils';
var defaultProps = {
  isSuccess: false,
  closeDelay: 4,
  onClose: null,
  image: null
};
var Modal = /*#__PURE__*/function (_React$Component) {
  _inherits(Modal, _React$Component);
  var _super = _createSuper(Modal);
  function Modal(props) {
    var _this;
    _classCallCheck(this, Modal);
    _this = _super.call(this, props);
    _this.wasSubmitted = _this.wasSubmitted.bind(_assertThisInitialized(_this));
    _this.shouldDisplayModal = _this.shouldDisplayModal.bind(_assertThisInitialized(_this));
    _this.hijackCloseEmailCapture = _this.hijackCloseEmailCapture.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(Modal, [{
    key: "shouldDisplayModal",
    value: function shouldDisplayModal() {
      var _this$props = this.props,
        locationId = _this$props.locationId,
        isVisible = _this$props.isVisible;
      var wasClosed = formWasClosed(locationId);
      var wasSubmitted = this.wasSubmitted();
      if (!isVisible) {
        return false;
      }
      if (wasClosed || wasSubmitted) {
        return false;
      }
      return true;
    }
  }, {
    key: "wasSubmitted",
    value: function wasSubmitted() {
      var _this$props2 = this.props,
        locationId = _this$props2.locationId,
        isSuccess = _this$props2.isSuccess;
      return formWasSubmitted(locationId) || isSuccess;
    }
  }, {
    key: "hijackCloseEmailCapture",
    value: function hijackCloseEmailCapture() {
      var quickClose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var _this$props3 = this.props,
        closeEmailCapture = _this$props3.closeEmailCapture,
        locationId = _this$props3.locationId,
        closeDelay = _this$props3.closeDelay;
      setFormAsClosed(locationId);
      if (quickClose) {
        closeEmailCapture(0);
      } else {
        closeEmailCapture(closeDelay * 1000);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        onClose = _this$props4.onClose,
        image = _this$props4.image;
      var shouldDisplayModal = this.shouldDisplayModal();
      var size = 'tiny';
      if (image && ['left', 'right'].includes(image.placement)) {
        size = 'large';
      }
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BaseModal, {
        open: shouldDisplayModal,
        onClose: onClose,
        dimmer: "inverted",
        size: size
      }, /*#__PURE__*/React.createElement(Form, _extends({}, this.props, {
        closeEmailCapture: this.hijackCloseEmailCapture
      }))));
    }
  }]);
  return Modal;
}(React.Component);
Modal.defaultProps = defaultProps;
export default Modal;